import { AnalyticsParams, track } from './analytics';

export class ListeningAnalytics {
  private running = false;
  private started = false;
  private lastTime = 0;
  private lastPosition = 0;
  private pending = 0;
  private pendingAudio = 0;
  private milestones = new Set<number>();
  constructor(private context: AnalyticsParams, private emit = track, private now = () => performance.now()) {}
  updateContext(context: AnalyticsParams) { this.context = context; }
  event(name: string, audio: HTMLAudioElement, extra: AnalyticsParams = {}) {
    this.emit(name, { ...this.context, position_seconds: audio.currentTime || 0,
      duration_seconds: Number.isFinite(audio.duration) ? audio.duration : undefined,
      playback_rate: audio.playbackRate, ...extra });
  }
  start(audio: HTMLAudioElement) {
    if (this.running) return;
    this.running = true;
    this.reset(audio);
    this.event(this.started ? 'audiobook_resumed' : 'audiobook_started', audio);
    this.started = true;
  }
  reset(audio: HTMLAudioElement) { this.lastTime = this.now(); this.lastPosition = audio.currentTime; }
  sample(audio: HTMLAudioElement) {
    const wall = Math.max(0, (this.now() - this.lastTime) / 1000);
    const moved = audio.currentTime - this.lastPosition;
    const rate = audio.playbackRate || 1;
    if (this.running && !audio.seeking && moved > 0 && moved <= wall * rate * 1.25 + 0.25) {
      this.pending += Math.min(wall, moved / rate);
      this.pendingAudio += moved;
      const percent = audio.duration > 0 ? 100 * audio.currentTime / audio.duration : 0;
      const previous = audio.duration > 0 ? 100 * this.lastPosition / audio.duration : 0;
      for (const milestone of [25, 50, 75, 90]) {
        if (previous < milestone && percent >= milestone && !this.milestones.has(milestone)) {
          this.milestones.add(milestone);
          this.event('audiobook_progress', audio, { milestone, position_percent: percent });
        }
      }
    }
    this.reset(audio);
    if (this.pending >= 30) this.flush(audio);
  }
  flush(audio: HTMLAudioElement) {
    if (this.pending > 0) {
      this.event('audiobook_listening', audio, { listening_seconds: this.pending, audio_seconds: this.pendingAudio });
      this.pending = 0; this.pendingAudio = 0;
    }
  }
  stop(audio: HTMLAudioElement, event?: string) {
    this.sample(audio); this.flush(audio);
    if (this.running && event) this.event(event, audio);
    this.running = false;
  }
}
